var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"show"}},[_c('section',{staticClass:"popup"},[_c('div',{staticClass:"popup__content"},[_c('router-link',{staticClass:"close-popup",attrs:{"to":"/"}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])]),_vm._v(" "),_c('div',{staticClass:"contact"},[_c('p',[_vm._v("Jednoduše nám zavolejte na")]),_vm._v(" "),_c('h1',[_vm._v("+420 602 879 396")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e481d3a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Popup.vue
// module id = null
// module chunks = 